import React, { useMemo } from "react";

import { Link } from "../wombat-ui";

import { getSkillsColor } from "../../utils/colors";
import { Tag, TagLabel, TagProps } from "@chakra-ui/react";
import { SkillFragment } from '../../graphql/generated/definitions';

type SkillTagProps = TagProps & {
  skill: SkillFragment;
  disabled?: boolean;
};

const SkillTag: React.FC<SkillTagProps> = ({
  skill,
  disabled = false,
  children,
  id,
  ...props
}) => {
  const havingAnswersMatching = useMemo(
    () => JSON.stringify([{ skillId: skill.id }]),
    [skill.id]
  );

  return (
    <Tag
      size="md"
      variant="solid"
      colorScheme={getSkillsColor(skill?.kind)}
      {...props}
    >
      <TagLabel
        color="currentcolor"
        as={Link}
        to={`/users?havingAnswersMatching=${encodeURIComponent(
          havingAnswersMatching
        )}`}
        data-test-id={`badge_skill_badge_${skill.id}`}
        disabled={disabled}
      >
        {skill.name}
      </TagLabel>
      {children}
    </Tag>
  );
};

export default SkillTag;
